module.exports = __webpack_public_path__ + "119bd24ff4a608ef7d5901728f475934.png";